import { HttpResponseError } from 'src/service/backend/error/HttpResponseError'

export class AuthenticationError extends HttpResponseError {}
